<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex">
            <section class="mu-d-flex">
                <h1 class="mu-mb-00">Global process properties</h1>
                <details class="mcc-popover mcc-popover--bottom-end">
                    <summary class="mcc-button mcc-button--icon-only ">
                        <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                    </summary>
                    <div class="mcc-popover__content">
                        <p class="mu-mb-00">
                            {{ helpText.title }}
                            <a :href="helpText.url" target="_blank">Read more...</a>
                        </p>
                    </div>
                </details>
            </section>
        </div>
        <div>
        </div>
    </div>
    <div class="card-padding">
        <nav aria-label="breadcrumb" class="mu-mt-05">
            <ol class="mcc-breadcrumb">
                <li>Design</li>
                <li aria-current="page">Global process properties</li>
            </ol>
        </nav>
        <div class="mcc-row">
            <div class="mcc-col">
                <div style="position:relative">
                    <div v-if="!updateCall" class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                    <form novalidate id="customDataListForm" @submit.prevent="saveProperties()">
                        <div class="mcc-card">
                            <div class="mcc-card__header">
                                <h2 class="mcc-card__title  "></h2>
                            </div>
                            <div class="mcc-card__body">
                                <mfc-row-repeater ref="globalPprocessPropsRef" id="globalPprocessProps">
                                    <mfc-input type="text" required="true" name="globalPropName" id="globalPropName" maxlength="50" label="Property name" nameAttr="nameAttr"></mfc-input>
                                    <mfc-input type="text" required="true" name="globalPropValue" id="globalPropValue" maxlength="100" label="Property value" valueAttr="valueAttr"></mfc-input>
                                    <mfc-input type="hidden" class="d-none" name="id" id="globalProcessId"></mfc-input>
                                </mfc-row-repeater>
                                <div class="mu-d-flex mu-justify-content-end d-flex justify-content-end mt-3" spaced="">
                                    <button class="mcc-button mcc-button--success" id="saveBtn" title="Save" type="submit">
                                        <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import constantMessages from "@/messages";
import GlobalProcessPropertiesAPI from "../../services/GlobalProcessPropertiesAPI";
import {
    EventBus
} from "../../services/event-bus";
import Utils from "@/script_utils";
import {
    displayErrorMessage
} from '../../formvalid.js';

export default {
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["globalprocessprops"],
            showHelpText: false,
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            updateCall: true,
            properties: []
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        let self = this;
        self.updateCall = false;
        GlobalProcessPropertiesAPI.getProperties().then(response => {
            if (response != null && response.length > 0) {
                self.properties = response;
                setTimeout(function () {
                    self.updateCall = true;
                    self.$refs.globalPprocessPropsRef.setData(response, {});
                }, 2000);
            } else {
                self.updateCall = true;
            }
        });
    },
    methods: {
        validateNameField(component, dataVal) {
            let valid = true;

            if (dataVal == "") {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.globalproperties.name"])
                component[0].classList.add("ms-is-invalid")
                valid = false;
            } else if (dataVal.length > 50) {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.globalproperties.50"])
                component[0].classList.add("ms-is-invalid")
                valid = false;
            } else if (!dataVal.match(this.nameRegex)) {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.globalproperties.invalid"])
                component[0].classList.add("ms-is-invalid")
                valid = false;
            } else if (!Utils.isPropertyValid("nameAttr", "error.globalproperties.unique")) {
                valid = false;
            } else {
                Utils.removeExistingMessages("nameAttr", this.nameRegex, 50);
                component[0].classList.remove("ms-is-invalid")
                valid = true;
            }
            return valid
        },
        validateValueField(component, dataVal) {
            let valid = true;

            if (dataVal == "") {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.globalproperties.value"])
                component[0].classList.add("ms-is-invalid")
                valid = false;
            } else if (dataVal.length > 100) {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.globalproperties.value.100"])
                component[0].classList.add("ms-is-invalid")
                valid = false;
            } else if (!dataVal.match(this.descRegex)) {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.globalproperties.value.invalid"])
                component[0].classList.add("ms-is-invalid")
                valid = false;
            } else {
                Utils.removeExistingMessages("valAttr", this.descRegex, 50);
                component[0].classList.remove("ms-is-invalid")
                valid = true;
            }
            return valid
        },
        saveProperties() {
            let self = this;
            let propertyData = [];
            let nameFieldComp;
            let nameFieldValue;
            let valueFieldComp;
            let valueFieldvalue;
            let idFieldComp;
            let idFieldVal;
            let isValidNameField = true;
            let isValidValField = true;
            let isValid = true
            $(".mcc-row-repeater .mcc-row-repeater__row").each(function (index, row) {
                nameFieldComp = $(row).find("input[name^=globalPropName]");
                nameFieldValue = $(nameFieldComp).val();
                valueFieldComp = $(row).find("input[name^=globalPropValue]");
                valueFieldvalue = $(valueFieldComp).val();
                if ($(nameFieldComp)[0].name !== 'globalPropName-rr-0') {
                    isValidNameField = self.validateNameField(nameFieldComp, nameFieldValue);
                }
                if ($(valueFieldComp)[0].name !== 'globalPropValue-rr-0') {
                    isValidValField = self.validateValueField(valueFieldComp, valueFieldvalue)
                }
                if (!isValidNameField || !isValidValField) {
                    isValid = false
                }
            })
            if (!isValid) {
                return;
            }
            $(".mcc-row-repeater .mcc-row-repeater__row").each(function (index, row) {
                nameFieldComp = $(row).find("input[name^=globalPropName]");
                nameFieldValue = $(nameFieldComp).val();

                valueFieldComp = $(row).find("input[name^=globalPropValue]");
                valueFieldvalue = $(valueFieldComp).val();

                idFieldComp = $(row).find("input[name^=id]");
                idFieldVal = $(idFieldComp).val();
                let obj = {
                    "globalPropName": nameFieldValue,
                    "globalPropValue": valueFieldvalue,
                    "id": idFieldVal,
                };
                propertyData.push(obj);
            })
            propertyData.shift()
            self.updateCall = false;
            GlobalProcessPropertiesAPI.saveProperties(propertyData).then(response => {
                if (response.error) {
                    self.updateCall = true;
                    EventBus.$emit("error-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                } else if (response.data != null) {
                    self.properties = response.data;
                    let propertiesArr = [];
                    propertiesArr = response.data;
                    setTimeout(function () {
                        self.$refs.globalPprocessPropsRef.setData(propertiesArr, {});
                        self.updateCall = true;
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                    }, 1000);
                }
            });
        }
    }
};
</script>

<style scoped>
.mfc-invalid-feedback--show {
    display: flex !important;
}
</style>
